module.exports = __webpack_public_path__ + "static/media/start.629bb691.mp3";